import React from 'react';
import './Ubicacion.scss';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import "animate.css/animate.min.css";
import { useTranslation } from 'react-i18next';

const Ubicacion = (props) => {
  const { t } = useTranslation();

  const handleVideo = () => {
    props.setVideo(true);
    props.setUrlVideo("nNg9KYR4qQs");
  };

  return (
    <div className='contenedor_ubicacion'>
      <div className='contenedor_ubicacion__left'>
        <AnimationOnScroll
          duration={2}
          animateOnce={true}
          animateIn='animate__fadeIn'>
          <div className='contenedor_ubicacion__left_subtitulo'>
            <h2>{t('ubicacion.title')}</h2>
          </div>
        </AnimationOnScroll>
        <div className='contenedor_ubicacion__left_texto'>
          <p>{t('ubicacion.description')}</p>
        </div>
        <div className='contenedor_ubicacion__left_button'>
          <a href="#ubicacion">{t('ubicacion.button')}</a>
        </div>
      </div>
      <div className='contenedor_ubicacion__right'>
        {/* <img className='play' src="/assets/Logos/boton-de-play.png" alt={t('ubicacion.playAlt')} onClick={() => handleVideo()} /> */}
        <div className='contenedor_ubicacion__right_video'>
          <video src="/assets/Video/loop-corregidora.mp4" autoPlay muted loop></video>
        </div>
      </div>
    </div>
  );
};

export default Ubicacion;
